var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg4Desktop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 400,
    viewBox: "0 0 1400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_350_99900)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 376.104,
    cy: 549.171,
    rx: 376.104,
    ry: 549.171,
    transform: "matrix(0.697674 0.716415 -0.683113 0.730313 1513.45 -641.26)",
    fill: "url(#paint0_linear_350_99900)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_350_99900",
    x: 570.852,
    y: -825.969,
    width: 1659.7,
    height: 1710.44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 186,
    result: "effect1_foregroundBlur_350_99900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_350_99900",
    x1: 376.104,
    y1: 0,
    x2: 376.104,
    y2: 1098.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434BEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434BEE",
    stopOpacity: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg4Desktop);
export default __webpack_public_path__ + "static/media/bg4-desktop.661dae7d186fc36fcd42d63b7849664f.svg";
export { ForwardRef as ReactComponent };